export const FETCH_STAKEHOLDERS_LIST = 'FETCH_STAKEHOLDERS_LIST';
export const FETCH_STAKEHOLDERS_LIST_SUCCESS = 'FETCH_STAKEHOLDERS_LIST_SUCCESS';
export const FETCH_STAKEHOLDERS_LIST_FAILURE = 'FETCH_STAKEHOLDERS_LIST_FAILURE';
export const CLEAR_STAKEHOLDERS_LIST = 'CLEAR_STAKEHOLDERS_LIST';
